import { Link } from "react-router-dom";
import { BookOpen, Headphones, Quote } from "lucide-react";
import { formatDate, mediaUrl } from "@/lib/api";
import { SectionTitle } from "./SectionTitle";
import { NewsletterForm } from "./NewsletterForm";

export const Sidebar = ({ chronique, magazine, podcasts = [] }) => (
  <aside className="space-y-10">
    {chronique && (
      <div data-testid="sidebar-chronique">
        <SectionTitle to="/chronique">Chronique de la semaine</SectionTitle>
        <Link to={`/article/${chronique.slug}`} className="block bg-[#111827] text-white p-6 relative group">
          <Quote size={40} className="text-red-600 absolute right-4 top-4 opacity-60" />
          <h3 className="font-heading font-extrabold text-lg leading-snug group-hover:text-red-400 transition-colors pr-8">{chronique.title}</h3>
          <p className="text-sm text-zinc-400 mt-3 line-clamp-3">{chronique.excerpt}</p>
          <div className="text-xs text-zinc-500 mt-4">{chronique.author} · {formatDate(chronique.published_at)}</div>
          <span className="inline-block mt-4 bg-red-600 text-xs font-bold uppercase tracking-wider px-3 py-1.5">Lire la chronique</span>
        </Link>
      </div>
    )}
    {magazine && (
      <div data-testid="sidebar-magazine">
        <SectionTitle to="/magazine">Magazine</SectionTitle>
        <Link to="/magazine" className="news-card flex gap-4 p-4 group">
          <div className="w-24 aspect-[3/4] bg-zinc-200 overflow-hidden shrink-0 shadow-md">{magazine.cover_url && <img src={mediaUrl(magazine.cover_url)} alt="" className="w-full h-full object-cover" />}</div>
          <div>
            <div className="badge-cat">{magazine.edition}</div>
            <h3 className="font-heading font-bold mt-2 group-hover:text-red-600 transition-colors">{magazine.title}</h3>
            <p className="text-xs text-zinc-500 mt-1 line-clamp-3">{magazine.description}</p>
            <span className="inline-flex items-center gap-1 text-xs font-bold text-red-600 mt-2"><BookOpen size={12} /> Lire la liseuse</span>
          </div>
        </Link>
      </div>
    )}
    {podcasts.length > 0 && (
      <div data-testid="sidebar-podcasts">
        <SectionTitle to="/podcast">Podcast</SectionTitle>
        <div className="space-y-3">
          {podcasts.map((p) => (
            <Link key={p.id} to="/podcast" className="flex items-center gap-3 news-card p-3 group">
              <div className="w-12 h-12 bg-red-600 text-white flex items-center justify-center shrink-0"><Headphones size={18} /></div>
              <div className="min-w-0"><h4 className="font-heading font-bold text-sm line-clamp-2 group-hover:text-red-600 transition-colors">{p.title}</h4><div className="text-xs text-zinc-500">{p.host} · {p.duration}</div></div>
            </Link>
          ))}
        </div>
      </div>
    )}
    <div className="bg-white border border-zinc-200 p-5" data-testid="sidebar-newsletter">
      <h3 className="font-heading font-extrabold uppercase text-sm tracking-wide mb-2">Newsletter</h3>
      <p className="text-sm text-zinc-600 mb-3">L'essentiel de l'actualité congolaise chaque matin.</p>
      <NewsletterForm />
    </div>
  </aside>
);
